/**
 * @file Defines the {@link ONE_CLICK_HELP} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.23
 * @constant
 * @default
 */

export const ONE_CLICK_HELP = [ 'DE', 'MT' ]